import { FlatTreeControl } from '@angular/cdk/tree';
import { Injectable } from '@angular/core';
import { NodeDto, TreeNode, TreeNodeState } from '@app/features/hierarchy/models/hierarchy.model';
import { HierarchyService } from '@app/features/hierarchy/services/hierarchy.service';
import { Page } from '@app/shared/models/page.interface';
import { Observable } from 'rxjs';
import { TreeDataSource } from '../../pages/manager/edit/node-tree/node-tree.datasource';

@Injectable({ providedIn: 'root' })
export class TreeViewDataSource extends TreeDataSource {
  constructor(protected treeControl: FlatTreeControl<TreeNode>, protected hierarchyService: HierarchyService) {
    super(treeControl);
  }

  protected getPage(hierarchyId: string, nodeId: string, state: TreeNodeState): Observable<Page<NodeDto>> {
    return this.hierarchyService.getHierarchyNodeChildrenPaged(hierarchyId, nodeId, state);
  }

  protected getHierarchyNodesRecursive(hierarchyId: string, filter: string): Observable<NodeDto[]> {
    return this.hierarchyService.getHierarchyNodesRecursive(hierarchyId, filter);
  }
}
